import { Controller } from "@hotwired/stimulus"

// Chips + hidden inputs for the workspace BCC list. The server owns validation;
// this only mirrors the list into workspace[document_email_bcc][] as chips.
export default class extends Controller {
  static targets = ["chips", "input", "chipTemplate"]
  static values = { locked: Boolean, owner: String, removeLabel: String }

  add(event) {
    event?.preventDefault?.()
    if (this.lockedValue) return
    const address = this.inputTarget.value.trim()
    if (address === "") return

    const existing = Array.from(this.chipsTarget.querySelectorAll(".document-emails__chip"))
      .map((chip) => chip.dataset.address?.toLowerCase())
    if (!existing.includes(address.toLowerCase())) {
      // lastElementChild is the always-posted empty input — the chip goes before it.
      this.chipsTarget.insertBefore(this.buildChip(address), this.chipsTarget.lastElementChild)
    }
    this.inputTarget.value = ""
  }

  remove(event) {
    if (this.lockedValue) return
    const chip = event.currentTarget.closest(".document-emails__chip")
    chip?.remove()
  }

  // DOM nodes and textContent only: an address is data, never markup
  // (.claude/rules/backend/security.md, output escaping). The chip's structure
  // is cloned from the <template> the view renders once.
  buildChip(address) {
    const chip = this.chipTemplateTarget.content.firstElementChild.cloneNode(true)
    chip.dataset.address = address
    chip.querySelector("[data-chip-address]").textContent = address

    const ownerLabel = chip.querySelector("[data-chip-owner]")
    if (address.toLowerCase() !== this.ownerValue.toLowerCase()) ownerLabel.remove()

    chip.querySelector("button").setAttribute("aria-label", `${this.removeLabelValue} ${address}`)
    chip.querySelector("input[type=hidden]").value = address
    return chip
  }
}
